import React from "react";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { ShieldCheck, Clock, CreditCard, Mail, ArrowRight, MapPin } from "lucide-react";

const POINTS = [
  { icon: MapPin, title: "Singapore-registered organisations", body: "Lestari self-service is built for Singapore entities — declare your UEN / business registration number to begin." },
  { icon: Mail, title: "Start with your work email", body: "No government login needed — verify your company email with a 6-digit code we send you." },
  { icon: Clock, title: "15 calendar-day trial", body: "Reach a usable ESG control tower within minutes — guided every step by AI." },
  { icon: CreditCard, title: "No payment to start", body: "No card required for the trial. Activate a paid package only when you're ready." },
];

export function IntroStage({ onStart, busy }) {
  return (
    <div className="max-w-3xl" data-testid="intro-stage">
      <Badge variant="lime" className="mb-5 px-3 py-1 text-xs tracking-[0.18em]" data-testid="intro-trial-badge">15-DAY TRIAL · SINGAPORE</Badge>
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05]">
        Stand up your ESG control tower in minutes.
      </h1>
      <p className="text-muted-foreground mt-4 text-base max-w-xl leading-relaxed">
        Verify your organisation, provision a secure tenant, and capture your ESG baseline — guided by an AI adviser the
        whole way. No sales calls, no spreadsheets to email around.
      </p>

      <div className="grid sm:grid-cols-2 gap-3 mt-8">
        {POINTS.map((p) => (
          <div key={p.title} className="card-flat bg-surface p-4 flex gap-3">
            <div className="h-9 w-9 rounded-sm bg-accent/15 border border-accent/30 flex items-center justify-center shrink-0">
              <p.icon className="h-4 w-4 text-accent" strokeWidth={2} />
            </div>
            <div>
              <div className="text-sm font-semibold">{p.title}</div>
              <div className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{p.body}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-9 flex items-center gap-4">
        <Button variant="primary" size="lg" onClick={onStart} disabled={busy} data-testid="start-trial-btn" className="gap-2">
          <ShieldCheck className="h-4 w-4" />
          {busy ? "Preparing…" : "Start 15-day trial"}
          <ArrowRight className="h-4 w-4" />
        </Button>
        <a href="/login" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="intro-login-link">
          Already have an account? Sign in
        </a>
      </div>
    </div>
  );
}
